// Budget and financial planning components
import { defineAsyncComponent } from 'vue'

export default {
  BudgetEditAll: defineAsyncComponent(() => import('../budget_edit_all.vue')),
  BudgetForecastsIndex: defineAsyncComponent(
    () => import('../admin/budget_forecasts/index.vue')
  )
}
